import { createSlice, type PayloadAction } from "@reduxjs/toolkit"
import type { RootState } from "../index"
import type { ProductType } from "@/content/products"
import type { TreatmentId, TreatmentWeeks } from "@/content/treatments"
import type { ServiceId } from "@/content/services"

export type CartItemId = ProductType | TreatmentId | ServiceId

export interface CartProduct {
	id: CartItemId
	priceId: string
	amount: number
	duration?: TreatmentWeeks
}

export interface CartState {
	isLoading: boolean
	products: CartProduct[]
}

const initialState: CartState = {
	isLoading: false,
	products: []
}

export const cartSlice = createSlice({
	name: "cart",
	initialState,
	reducers: {
		addProduct: (state, action: PayloadAction<CartProduct>) => {
			const existing = state.products.find(({ id }) => id === action.payload.id)
			if (existing) {
				existing.amount += action.payload.amount
			} else {
				state.products.push(action.payload)
			}
		},
		updateProductAmount: (state, action: PayloadAction<{ id: CartItemId; newAmount: number }>) => {
			const product = state.products.find(({ id }) => id === action.payload.id)
			if (product) {
				product.amount = action.payload.newAmount
			}
		},
		removeProduct: (state, action: PayloadAction<CartItemId>) => {
			state.products = state.products.filter(({ id }) => id !== action.payload)
		},
		resetCart: state => {
			state.products = []
		},
		// Restaura el carrito persistido (localStorage) tras la hidratación en cliente.
		hydrateCart: (state, action: PayloadAction<CartProduct[]>) => {
			state.products = action.payload
		},
		setLoader: (state, action: PayloadAction<boolean>) => {
			state.isLoading = action.payload
		}
	}
})

export const { addProduct, updateProductAmount, removeProduct, resetCart, setLoader, hydrateCart } = cartSlice.actions

export default cartSlice.reducer

export const selectProducts = (state: RootState): CartProduct[] => state.cart.products
export const selectLoader = (state: RootState): boolean => state.cart.isLoading
